module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg app",
    attrs: {
      "id": "gwi-index"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('health-card-swiper', {
    attrs: {
      "healthCardList": _vm.healthCardList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "module banner"
  }, [_c('icon-menu', {
    attrs: {
      "name": "register"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/home/banner2.png")
    }
  })]), _vm._v(" "), _c('icon-menu', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "name": "pay"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/home/banner1.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "module channel"
  }, [(_vm.channel !== 'TFY' && _vm.channel !== 'TFTB' && _vm.channel !== 'TFRYB') ? _c('icon-menu', {
    attrs: {
      "name": "outregister"
    }
  }, [_c('div', [_vm._v("市外挂号")])]) : _vm._e(), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "myregister"
    }
  }, [_c('div', [_vm._v("挂号记录")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "mypay"
    }
  }, [_c('div', [_vm._v("缴费记录")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "myreport"
    }
  }, [_c('div', [_vm._v("查询报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "module menu"
  }, [_c('icon-menu', {
    attrs: {
      "name": "residentHealthRecord"
    }
  }, [_c('p', [_vm._v("健康档案")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "MyPrescription"
    }
  }, [_c('p', [_vm._v("电子处方")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "InpatientRegister"
    }
  }, [_c('p', [_vm._v("住院登记")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "waitDoctor"
    }
  }, [_c('p', [_vm._v("排队候诊")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "healthRecord"
    }
  }, [_c('p', [_vm._v("健康证申领")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "inMap"
    }
  }, [_c('p', [_vm._v("院内导航")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "inpatientprepay"
    }
  }, [_c('p', [_vm._v("住院预缴")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "HospitalCostList"
    }
  }, [_c('p', [_vm._v("住院费用查询")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "hosinfo"
    }
  }, [_c('p', [_vm._v("医院介绍")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "bedsinfo"
    }
  }, [_c('p', [_vm._v("床位查询")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "familyDoctor"
    }
  }, [_c('p', [_vm._v("家医签约")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "selfHealthAssessment"
    }
  }, [_c('p', [_vm._v("健康评估")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "emergencyCall"
    }
  }, [_c('p', [_vm._v("急救呼叫")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "heathGuide"
    }
  }, [_c('p', [_vm._v("健康指导")])]), _vm._v(" "), _c('applet-icon-menu', {
    attrs: {
      "name": "AI健康小助手",
      "appid": "wx4616f848767a6431",
      "icon-src": require('../../../static/img/home/menu16.png'),
      "user-name": "gh_10015f7c55a5",
      "path": "pages/home/index"
    }
  }), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "internetHospital"
    }
  }, [_c('p', [_vm._v("互联网医院")])]), _vm._v(" "), _c('icon-menu', {
    attrs: {
      "name": "SurveyList"
    }
  }, [_c('p', [_vm._v("满意度评价")])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHealthAdvice),
      expression: "showHealthAdvice"
    }],
    staticClass: "healthAdviceTip"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n          1.专家提示：在线咨询不能取代线下面诊，如出现发热、乏力、咳嗽、呼吸困难等呼吸道症状，请戴上口罩立即前往就近定点医院就医。\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "mt10"
  }, [_vm._v("\n          2.您好！请将您的问题，在【健康彭州就医通】微信公众号对话框中编辑好，发送给我们，我们会尽快回复您！\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showHealthAdvice = false
      }
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-643fa2ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/Home.vue
// module id = 843
// module chunks = 0